import type { CustomFilterProps } from "ag-grid-react";
import i18n from "i18next";
import React from "react";
import { useSelector } from "react-redux";
import MultiSelectFilter from "src/components/AgGrid/Filters/MultiSelectFilter";
import { userStatus, userStatusTranslated } from "src/constants/users";
import { getUsersById } from "src/reducers";
import type { State } from "src/types";

const StatusFilter = (props: CustomFilterProps): React.ReactElement => {
  const usersById = useSelector(({ app }: State) => getUsersById(app));

  const allStatusValues = [
    userStatus.active,
    userStatus.pending,
    userStatus.disabled,
  ];

  return (
    <MultiSelectFilter
      {...props}
      filterType="status"
      data={usersById}
      getValueFromData={(usersById, uid) => {
        const user = usersById[uid];
        if (!user) return userStatus.active;
        if (user.disabled) return userStatus.disabled;
        if (user.invitePending) return userStatus.pending;
        return userStatus.active;
      }}
      renderValue={(value) => i18n.t(userStatusTranslated[value])}
      fixedValues={allStatusValues}
    />
  );
};

export default StatusFilter;
